import { render } from "./consumeTypesModel.vue?vue&type=template&id=31e8067a"
import script from "./consumeTypesModel.vue?vue&type=script&lang=js"
export * from "./consumeTypesModel.vue?vue&type=script&lang=js"

import "./consumeTypesModel.vue?vue&type=style&index=0&id=31e8067a&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__